<template>
<div class="zap-slideout-container" :class="{ isOpen: isOpen }">
  <div class="zap-slideout-opener hide-cursor"
    @click="toggle">
    <div id="nav-icon3">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div class="zap-slideout"
      :class="{ isOpen: isOpen, 'hide-cursor': true}">
    <div>
      <ul class="zap-slideout-menu">
        <li class="language-selector zap-slideout-menu-item">
          <a href="#" @click="setLanguage('nl')" :class="{ active: language === 'nl'}">NL</a>
          <a href="#" @click="setLanguage('en')" :class="{ active: language === 'en'}">ENG</a>
        </li>
        <li @click="close"
            class="zap-slideout-menu-item"
            v-for="item in menu">
          <router-link
              v-bind:class="'slideout-item-' + item.title"
              v-bind:to="item.url[language]">{{item.title[language]}}</router-link>
        </li>
        <li @click="toggleColofon" class="zap-slideout-menu-item">
          <a class="slideout-item-Colofon"><span v-lang.slideout.colofon.title></span></a>
        </li>
        <li class="zap-slideout-menu-item">
          <a href="#" class="slideout-item-Introduction" @click="showIntro"><span v-lang.slideout.intro></span></a>
        </li>
      </ul>
    </div>
  </div>
  <div v-bind:class="{colofon: true, 'hide-cursor': true, open: showColofon}">
    <h2><span v-lang.slideout.colofon.title></span></h2>
    <div class="copy" v-lang.slideout.colofon.body>
    </div>
    <a class="studio-link srj" target="_blank" href="https://www.ruiterjanssen.nl/"><img src="static/img/logo_studio_ruiter_janssen.png" alt=""></a>
    <a class="studio-link zam" target="_blank" href="https://zammagazine.com/"><img src="static/img/logo_zam.png" alt=""><span class="tagline">Building a world beyond them and us.</span></a>
    <a class="studio-link abz" target="_blank" href="http://www.afdelingbuitengewonezaken.nl/"><img src="static/img/logo_studio_afdeling_buitengewone_zaken.png" alt=""></a>
    <a class="studio-link cif" target="_blank" href="https://stimuleringsfonds.nl/en/"><img src="static/img/logo_stimuleringsfonds.gif" alt=""></a>
  </div>
</div>
</template>

<script>
export default {
  name: 'zap-slideout',
  mounted () {
    this.$bus.$on('click', this.close.bind(this))
    this.$bus.$on('touchend', this.close.bind(this))
  },
  data: () => ({
    openerText: 'Open',
    isOpen: false,
    showColofon: false,
    menu: [
      {
        title: {
          en: 'Rooftop',
          nl: 'Dak'
        },
        url: {
          en: '/rooftop/',
          nl: '/rooftop/'
        }
      },
      {
        title: {
          en: 'Who',
          nl: 'Wie'
        },
        url: {
          en: '/overview/who/the-architect-of-apartheid',
          nl: '/overview/who/de-architect-van-apartheid'
        }
      },
      {
        title: {
          en: 'Where',
          nl: 'Waar'
        },
        url: {
          en: '/overview/where/homelands',
          nl: '/overview/where/thuislanden'
        }
      },
      {
        title: {
          en: 'What',
          nl: 'Wat'
        },
        url: {
          en: '/overview/what/racial-hierarchy-ethnic-division',
          nl: '/overview/what/raciale-hirarchie-etnische-verdeling'
        }
      },
      {
        title: {
          en: 'Why',
          nl: 'Waarom'
        },
        url: {
          en: '/overview/why/fifty-shades-of-fear',
          nl: '/overview/why/vijftig-tinten-angst'
        }
      },
      {
        title: {
          en: 'When',
          nl: 'Wanneer'
        },
        url: {
          en: '/overview/when/1948',
          nl: '/overview/when/1948'
        }
      },
      {
        title: {
          en: 'Extremes',
          nl: 'Extremen'
        },
        url: {
          en: '/overview/extremes/income-then-and-now',
          nl: '/overview/extremes/income-then-and-now'
        }
      },
      {
        title: {
          en: 'Double Dutch',
          nl: 'Double Dutch'
        },
        url: {
          en: '/overview/double-dutch/apartheid-south-africa-the-flag',
          nl: '/overview/double-dutch/apartheid-zuid-afrika-de-vlag'
        }
      },
      {
        title: {
          en: 'The End',
          nl: 'Het Einde?'
        },
        url: {
          en: '/overview/the-end/purple-rain',
          nl: '/overview/the-end/purple-rain'
        }
      }
    ],
    smallMenu: [ 'Tips', 'Resources', 'Shenanigans' ]
  }),
  methods: {
    open () {
      this.openerText = 'Close'
      this.isOpen = true
    },
    close () {
      this.openerText = 'Open'
      this.showColofon = false
      this.isOpen = false
    },
    setLanguage (lang) {
      this.language = lang
      this.$bus.$emit('lang-changed', lang)
      window.setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    toggle () {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
    toggleColofon () {
      this.showColofon = !this.showColofon
    },
    showIntro () {
      this.$bus.$emit('show-intro')
      this.close()
    }
  }
}
</script>

<style lang="scss">
.zap-slideout {
  position: absolute;
  width: 240px;
  height: 100vh;
  padding: 48px 30px 38px;
  background-color: #ffffff;
  transform: translateX(-100%);
  transition: transform 0.6s ease-out;
  z-index: 4;
  border-right: 1px solid #eeeeee;
  // box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.2);

  &.isOpen {
    transform: translateX(0);
    // overflow-y: auto;
    box-sizing: border-box;
  }
}

.zap-slideout-opener {
  height: 48px;
  left: 0;
  position: fixed;
  top: 0;
  padding: 0px 20px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #000;
  z-index: 9999;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
  li:hover {
    border-bottom: 2px solid black;
    margin-bottom: -2px;
  }
}

.zap-slideout-menu {
  font-weight: 600;
  color: #000;
}

.zap-slideout-menu-item,
.zap-slideout-menu-item--small {
  cursor: pointer;
  position: relative;
  display: block;

  &:nth-child(2) {
    font-weight: 100;
  }

  &:hover {
    text-decoration: none;
  }

  &:not(.language-selector):hover::after{
    content: '';
    display: block;
    background: black;
    position: absolute;
    height: 1px;
    bottom: 4px;
    left: 0;
    right: 0;
  }

  & + & {
    margin-top: 10px;
  }
}
.language-selector{
  position: absolute;
  top: 12px;
  & a {
    font-size: 18px;
  }
  & a:hover{
    text-decoration: underline;
  }
}

.zap-slideout-menu-item {
  font-size: 24px;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;

  & + .zap-slideout-menu-item--small {
    margin-top: 30px;
  }

  a {
    color: black;
    text-decoration: none;
  }
}

.zap-slideout-menu-item--small {
  font-size: 18px;
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #000;
}

/* The famed Zap agency logo (TM) */
.zap-emoji {
  height: 120px;
}


#nav-icon3 {
  width: 20px;
  height: 24px;
  position: relative;
  top: 4px;
  left: 0;
  margin: 8px auto;
 -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}

#nav-icon3 span {
  display: block;
  position: absolute;
  height: 4px;
  background: #000;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  right: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

/* Icon 3 */



#nav-icon3 span:nth-child(1) {
  top: 0px;
}

#nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
  top: 10px;
}

#nav-icon3 span:nth-child(4) {
  top: 20px;
}


.isOpen #nav-icon3 {
  top: 10px;
}

.isOpen #nav-icon3 span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

.isOpen #nav-icon3 span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.isOpen #nav-icon3 span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.isOpen #nav-icon3 span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#app.rooftop .zap-slideout-opener #nav-icon3 span {
    color: white;
    background: white;
}
.language-selector a {
  margin: 0;
  font-weight: 100;
}
.language-selector a.active {
  font-weight: bold;
}

.colofon {
  position: absolute;
  top: 0;
  left: -664px;
  width: 600px;
  max-width: 100%;
  bottom: 0;
  background: white;
  text-align: left;
  padding: 0 32px;
  transition: 0.5s ease-in-out;
  z-index: 2;
  overflow-y: scroll;

  h2 {
    font-size: 24px;
    text-align: left;
    font-weight: 900;
  }

  &.open {
    left: 239px;
  }

  .copy {
    margin-bottom: 32px;
  }

  .studio-link {
    display: block;
    text-decoration: none;
    margin-bottom: 20px;

    .tagline {
      display: block;
      color: black;
    }

    &.srj {
      img {
        height: 32px;
      }
    }
    &.zam {
      img {
        height: 32px;
      }
    }

    &.abz{
      margin-bottom: 14px;

      img {
        height: 28px;
      }
    }

    &.cif {
      img {
        max-height: 64px;
      }
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/Slideout.vue